import { Button, Grid, Typography } from "@mui/material";
import SelectTypeOfDashboard from "../../../components/Table/Dashboard/SelectTypeOfDashboard";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import { useAllSuscripsDashboard } from "../../../context/SuperAdmin/DashboardContexts/AllSuscriptions";
import SingleTotalCreditos from "../../../components/Table/Dashboard/SingleEntity/SingleTotalCreditos";
import SingleMonthlyCredits from "../../../components/Table/Dashboard/SingleEntity/SingleMonthlyCredits";

const SingleSuscrDashboard = () => {
  const {
    selectedSuscription,
    isLoadingTotalCredits,
    isLoadingMonthlyCredits,
    monthlyCredits,
    months,
    startMonth,
    monthlyCreditsFilters,
    changeMonths,
    updateStartingMonth,
    handleToggleMonthlyCredit,
  } = useAllSuscripsDashboard();
  const navigate = useNavigate();

  if (!selectedSuscription) return;

  return (
    <SelectTypeOfDashboard routeValue="suscriptions">
      {/* Header de Single Suscription */}
      <Grid
        container
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        {/* Título */}
        <Grid item>
          <Typography
            variant={"h5"}
            sx={{ color: "#005559", fontSize: "24px" }}
          >
            <b>Suscripción</b> | {selectedSuscription?.plan}
          </Typography>
        </Grid>

        {/* Boton para volver */}
        <Grid item>
          <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
            <ArrowBackOutlinedIcon />
            Volver
          </Button>
        </Grid>
      </Grid>

      {/* Pie Charts con el resume de los créditos totales */}
      <SingleTotalCreditos
        credits={selectedSuscription}
        isLoading={isLoadingTotalCredits}
      />

      {/* Créditos mensuales */}
      <SingleMonthlyCredits
        isLoading={isLoadingMonthlyCredits}
        monthlyCredits={monthlyCredits}
        startMonth={startMonth}
        months={months}
        changeMonths={changeMonths}
        updateStartingMonth={updateStartingMonth}
        creditsFilters={monthlyCreditsFilters}
        handleToggleCredit={handleToggleMonthlyCredit}
      />
    </SelectTypeOfDashboard>
  );
};

export default SingleSuscrDashboard;
